module.exports = __webpack_public_path__ + "media/images/countryrect/tl-20179488d6c8ceb76dfa91faa23fd971.svg";